import React from 'react';
import logo from '../../images/brand-color.svg';


const Logo = () =>(
    
        <>                
            <a href="/" className="brandContent">
                <img src={logo} className="logo" alt="XDneo" title="XDneo" />
            </a>
        </>
    )

export default Logo;